import React from "react";
import Particles from "../Particles/Particles";
import Mission from "../Mission";
import Vision from "../Vision";
import AboutTeam from "../AboutTeam";
import Testimonials from "../Testimonials";
import MessageFromCeo from "../MessageFromCeo";
import WhoWe from "../WhoWe";
import MissionAndVision from "../MissionAndVision";
import OurValues from "../OurValues";
import OurApproach from "../OurApproach";
import AboutUsBottomPage from "../AboutUsBottomPage";

const AboutPage = () => {
  return (
    <>
      <Particles title="About Us" subTitle="Know More About Us" page="about" />
      <WhoWe />
      <MissionAndVision />
      <OurValues />
      {/* <Mission /> */}
      {/* <Vision /> */}
      {/* <AboutTeam /> */}
      <MessageFromCeo />
      <OurApproach />
      <AboutUsBottomPage />
      {/* <Testimonials /> */}
    </>
  );
};

export default AboutPage;
